import React from 'react';
import { themeColor } from '../../theme/colors';
import { smRegular } from '../../theme/typography';
import styled, { css } from 'styled-components';

export function TreemapLegend({ ...rest }): JSX.Element {
  return (
    <Container {...rest}>
      <Title>Unutilized</Title>
      <Gradient />
      <Title>Most utilized</Title>
    </Container>
  );
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
`;

const Title = styled.div`
  ${smRegular}
  color: ${themeColor('textTertiary')};
`;

const Gradient = styled.div`
  width: 100px;
  height: 10px;

  border-radius: 2px;
  ${(props) =>
    props.theme.name === 'dark'
      ? css`
          border: 1px solid #252729;
          background: linear-gradient(90deg, #173735 0%, #0ffee6 100%);
        `
      : css`
          background: linear-gradient(
            90deg,
            black 10%,
            #eefffd 0%,
            #0bb1a1 100%
          );
        `}
`;
